import { Dashboard as CommonDashboard } from '../pages/Dashboard'; // ダッシュボード
import { default as CommonWorkSchedule } from '../pages/WorkSchedule'; // 作業予定一覧
import { WorkScheduleAll } from '../pages/WorkScheduleAll';
import { default as CommonWorkResult } from '../pages/WorkResult'; // 作業実績一覧
import { default as CommonWorkScheduleRegister } from '../pages/WorkScheduleRegister'; // 作業予定フォーム
import FieldTreePage from '../pages/FieldTree'; // 施工体系図
import { Fields } from '../pages/Fields'; // 現場一覧
import { GatePassages } from '../pages/GatePassages'; // ゲート予定一覧
import { GatePassageRegister } from '../pages/GatePassageRegister'; // ゲート予定登録
import { GatePassageEdit } from '../pages/GatePassageEdit'; // ゲート予定編集
import { default as WorkResultRegister } from '../pages/WorkResultRegister'; // 作業実績フォーム
import { FieldRequestList } from '../pages/FieldRequestList'; // 新規現場申請承認一覧
import { CraneUses } from '../pages/CraneUses'; // 揚重機予定一覧
import { CraneUseRegister } from '../pages/CraneUseRegister'; // 揚重機予定フォーム
import { MachineryUses } from '../pages/MachineryUses'; // 機材予定一覧
import { MachineryUseRegister } from '../pages/MachineryUseRegister'; // 機材予定フォーム
import { PartnerCompanies } from '../pages/PartnerCompanies'; // 協力会社一覧
import ConstructionPlacementPlace from '../pages/ConstructionPlacementPlace';
import Layout from '../pages/Layout';
import KeyplanLayout from '../pages/KeyplanLayout';
import ReportSettings from '../pages/ReportSettings';
import { FieldImages } from '../pages/FieldImages';
import { Keyplan } from '../pages/Keyplan';
import { FieldItemInputs } from '../pages/FieldItemInputs';
import { FieldAItems } from '../pages/FieldAItems';
import { WorkDates } from '../pages/WorkDates';
import { FieldApprovals } from '../pages/FieldApprovals';
import { PartnerCompaniesOrder } from '../pages/PartnerCompaniesOrder';
import { GroupSetting } from '../pages/GroupSetting'; // グループ設定
import { Gates } from '../pages/Gates';
import { Cranes } from '../pages/Cranes';
import { Machineries } from '../pages/Machineries';
import { Notifications } from '../pages/Notifications';
import { CranePrintSentences } from '../pages/CranePrintSentences';
import { TotalizeInfo } from '../pages/TotalizeInfo';
import { SafetyDiaries } from '../pages/SafetyDiaries';
import { WorkScheduleEdit } from '../pages/WorkScheduleEdit';
import { WorkResultEdit } from '../pages/WorkResultEdit';
import { ExternalServiceCooperation } from '../pages/ExternalServiceCooperation'; // 外部サービス連携
import WorkScheduleUnapproved from '../pages/WorkScheduleUnapproved';
import WorkResultUnapproved from '../pages/WorkResultUnapproved';
import { WorkScheduleUnapprovedEdit } from '../pages/WorkScheduleUnapprovedEdit';
import { WorkResultUnapprovedEdit } from '../pages/WorkResultUnapprovedEdit';
import { DirectApiSettingRedirect } from '../pages/DirectApiSettingRedirect';

// 入退場
import { InOutDashboard } from '../pages/InOutDashboard'; // 入退場ダッシュボード
import { InOutResult } from '../pages/InOutResult'; // 入退場実績
import { FieldTreeResult } from '../pages/FieldTreeResult'; // 実績集計
import { InOutHistoryUserUnregistered } from '../pages/InOutHistoryUserUnregistered'; // 不明な入退場データ
import { FieldSettings } from '../pages/FieldSettings'; // 現場設定
import { InOutFieldAreas } from '../pages/InOutFieldAreas'; // エリア一覧
import { 
  InOutFieldAreaNew, 
  InOutFieldAreaEdit,
} from '../pages/InOutFieldAreaForm'; // エリア編集・追加
import { EnterNameplates } from '../pages/EnterNameplates'; // 入場者名札QRコード
import { WorkerSettings } from '../pages/WorkerSettings'; // 作業員設定状況一覧
import {
  ResidentSpotWorkers,
  NonResidentSpotWorkers,
} from '../pages/SpotWorkers'; // 現場常駐社員一覧, 非常駐入退場者一覧
import { ProgressSchedule } from '../pages/ProgressSchedule';
import { ProgressScheduleEdit } from '../pages/ProgressScheduleEdit';
import { ProgressSelectWorkType } from '../pages/ProgressSelectWorkType';
import { ProgressChangeOrderOfWorkType } from '../pages/ProgressChangeOrderOfWorkType';
import { ProgressSettingLocation } from '../pages/ProgressSettingLocation';
import { ProgressSetting } from '../pages/ProgressSetting';

//労務安全
import { WorkLedger } from '../pages/WorkLedger'; // 施工体系台帳
import { SubcontractReNotify } from '../pages/SubcontractReNotify'; // 再下請負通知書
import { ConstructionWorkNotifyDetail } from '../pages/ConstructionWorkNotifyDetail'; // 施工体系台帳作成建設工事の通知
import { SubcontractorsTable } from '../pages/SubcontractorsTable'; // 下請負業者編成表

// BLDE_V2-40290 【POC】作業予定・実績一括編集画面の改善：ユーザーに公開しないため、画面とAPIを制御する
// POC確認が終わりましたので、対象画面への遷移出来ないように制限する。
import WorkScheduleBatchEdit from '../pages/WorkScheduleMultipleEdit';
import WorkResultBatchEdit from '../pages/WorkResultMultipleEdit';

//ページのコンポーネント一覧を定義
import LwGroups from '../pages/LwGroups';
import LwTalkrooms from '../pages/LwTalkrooms';
//ダッシュボード
export class Dashboard extends CommonDashboard { }

//作業予定一覧
export const WorkScheduleRegister = CommonWorkScheduleRegister;

//作業予定一覧
export class FieldTree extends FieldTreePage { }

export const WorkSchedule = CommonWorkSchedule;
export const WorkResult = CommonWorkResult;

//分割しない画面
export const singlepages = [
  'FieldTree',
  'Dashboard',
  'SafetyDiaries',
  'ConstructionPlacementPlace',
  'Layout',
];

//設定系画面は必ずここに記述する
export const setting = {
  FieldImages, //帳票用画像・その他資料
  Keyplan, //キープラン
  FieldItemInputs,
  FieldAItems,
  WorkDates,
  FieldApprovals,
  PartnerCompaniesOrder,
  GroupSetting, // グループ設定
  Gates,
  Cranes,
  Machineries,
  CranePrintSentences,
  TotalizeInfo,
};

export {
  Fields, // 現場一覧
  FieldRequestList, // 新規現場申請承認一覧
  GatePassages,
  GatePassageRegister,
  GatePassageEdit,
  WorkResultRegister,
  CraneUses,
  CraneUseRegister,
  MachineryUses,
  MachineryUseRegister,
  PartnerCompanies,
  ConstructionPlacementPlace,
  ReportSettings,
  SafetyDiaries,
  Layout,
  KeyplanLayout,
  Notifications,
  WorkScheduleEdit,
  WorkScheduleBatchEdit,
  WorkResultEdit,
  WorkResultBatchEdit,
  WorkScheduleAll,
  WorkScheduleUnapproved,
  WorkResultUnapproved,
  WorkScheduleUnapprovedEdit,
  WorkResultUnapprovedEdit,
  InOutDashboard,
  InOutResult,
  FieldTreeResult,
  InOutHistoryUserUnregistered,
  FieldSettings,
  InOutFieldAreas,
  InOutFieldAreaNew,
  InOutFieldAreaEdit,
  EnterNameplates,
  SubcontractReNotify,
  WorkLedger,
  ConstructionWorkNotifyDetail,
  SubcontractorsTable,
  WorkerSettings,
  ResidentSpotWorkers,
  NonResidentSpotWorkers,
  ExternalServiceCooperation, // 外部サービス連携
  LwGroups,
  LwTalkrooms,
  ProgressSchedule,
  ProgressScheduleEdit,
  ProgressSelectWorkType,
  ProgressChangeOrderOfWorkType,
  ProgressSettingLocation,
  ProgressSetting,
  DirectApiSettingRedirect,
};

//施工体系台帳



// WEBPACK FOOTER //
// ./src/components/pageComponents.js